// extracted by mini-css-extract-plugin
export default {"nav_list":"Nav_nav_list__khB6e","link":"Nav_link__zY5bM","active":"Nav_active__NO3N7"};